import { computed, Directive, input } from '@angular/core'
import { FieldErrorSource, fieldErrorMessage } from './field-error.logic'

export type { FieldErrorSource } from './field-error.logic'

/**
 * The error line of a Signal Forms field: `<mat-error [seiriFieldError]="form.name" />`.
 *
 * It stays a `<mat-error>`, so `mat-form-field` projects it and `MatError` links it to the input for
 * screen readers. The touched gating is its own, which makes the same element right under a control
 * outside a form field (a checkbox, a chip listbox), where nothing else would hide it.
 */
@Directive({
  selector: 'mat-error[seiriFieldError]',
  host: {
    class: 'seiri-field-error',
    '[textContent]': 'message()',
    '[style.display]': 'message() ? null : "none"',
  },
})
export class FieldErrorDirective {
  readonly field = input.required<FieldErrorSource>({ alias: 'seiriFieldError' })
  protected readonly message = computed(() => fieldErrorMessage(this.field()))
}
